function sendGA4EventTheme ({ event, payload }) {
    if (!window || !window.dataLayer) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
};
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4bec6b5c-4f1f-5a5f-ba58-d1639f77561d")}catch(e){}}();
//# debugId=4bec6b5c-4f1f-5a5f-ba58-d1639f77561d
